import type { FaireProductEntity } from "../../entity_types/product";

export const p_f66gv5vgcv: FaireProductEntity = {
  token: "p_f66gv5vgcv",
  type: "product",
  name: "Silver Sliding Tea Infuser",
  brandToken: "b_1dv8ay8smd",
  brandName: "Trishnna Tea",
  imageUrl:
    "https://cdn.faire.com/fastly/f2580f06d6b09ed9019e92d272f98fd80f442d58c70a4ff96443ecc3196aa499.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9717f2ea80fd249130fa95e841551157a7e38d98b796c653abadc8344d5c0ae.jpeg",
    "https://cdn.faire.com/fastly/767a4d257eaff6a98e432245b383cf725876934c2926a0594db6185168738921.jpeg",
  ],
  priceDollars: 4.99,
  description:
    "Tea infuser which holds exact amount of tea for one cup. Made with Plain Silver 304 Stainless Steel! Food grade material.\n\n**Christmas gift top seller***\n\n***Will be shipped in second week of January***\n\nProduct may be engraved with company name. Customs engraving available with lead time of 4-6 weeks.",
  tags: [],
  msrpDollars: 9.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:27:49.476Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
